<template>
    <router-view name="unauthenticated"></router-view>
</template>

<script>
    export default {
        name: 'unauthenticated'
    }
</script>
